import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { adminGetRoles, adminPutRoles } from "@/lib/api";

const ROLES = [
  { id: "buyer", label: "Buyer" },
  { id: "manufacturer", label: "Manufacturer" },
  { id: "creative", label: "Creative" },
];

export default function RolesAdmin() {
  const [roles, setRoles] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { adminGetRoles().then(setRoles).catch(() => toast.error("Failed to load role content")); }, []);

  if (!roles) return <div className="text-[#1F3864]/50 animate-pulse">Loading…</div>;

  const setField = (role, key, value) => setRoles((r) => ({ ...r, [role]: { ...(r[role] || {}), [key]: value } }));

  const save = async () => {
    setSaving(true);
    try {
      await adminPutRoles(roles);
      toast.success("Role content saved");
    } catch { toast.error("Save failed"); }
    setSaving(false);
  };

  return (
    <div data-testid="admin-roles">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-display font-bold text-3xl text-[#1F3864] mb-1">Customer Dashboards</h1>
          <p className="text-[#1F3864]/60">Edit the heading and subtext each role sees on their dashboard.</p>
        </div>
        <button data-testid="save-roles-btn" onClick={save} disabled={saving}
          className="inline-flex items-center gap-2 bg-[#1F3864] text-[#D7E85C] font-bold px-5 py-3 rounded-full hover:bg-[#16294B] disabled:opacity-50">
          <Save size={16} /> {saving ? "Saving…" : "Save changes"}
        </button>
      </div>

      <div className="space-y-4">
        {ROLES.map((r) => (
          <div key={r.id} data-testid={`role-${r.id}`} className="bg-white rounded-2xl border border-[#1F3864]/10 p-5">
            <div className="text-xs font-bold uppercase tracking-wider text-[#1F3864]/50 mb-3">{r.label} Dashboard</div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <label className="text-xs font-bold uppercase tracking-wider text-[#1F3864]/50">Heading</label>
                <input data-testid={`role-${r.id}-title`} value={roles[r.id]?.title || ""} onChange={(e) => setField(r.id, "title", e.target.value)}
                  className="mt-1 w-full border border-[#1F3864]/20 rounded-lg px-3 py-2.5 outline-none focus:border-[#1F3864] text-sm" />
              </div>
              <div>
                <label className="text-xs font-bold uppercase tracking-wider text-[#1F3864]/50">Subtext</label>
                <input data-testid={`role-${r.id}-subtitle`} value={roles[r.id]?.subtitle || ""} onChange={(e) => setField(r.id, "subtitle", e.target.value)}
                  className="mt-1 w-full border border-[#1F3864]/20 rounded-lg px-3 py-2.5 outline-none focus:border-[#1F3864] text-sm" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
